<template lang="pug">
	.asset-image-original-info(v-if="showed && asset" v-window)
		.card
			.card-header
				i.fa.fa-magic
				span Original Asset Info
			.card-body.collapse.show
				.form-line.original.separator
					.images(:class="{centered: true}")
						.image(:style="{backgroundImage: `url(${originalAssetUrl})`}" @click="editImage()")
				.form-actions
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import InputSelect			from './../Editor/Controls/InputSelect'
	import MultiSelect			from './../Editor/Controls/MultiSelect'

	export default {
		name: "AssetImageOriginalInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetImageOriginalInfo": function(variation, asset) {

					this.variation = variation;
					this.asset = asset;
					this.originalAssetUrl = Asset.getAssetOriginalUrl(this.asset);

					this.creative = Creative.SelectedCreative;

					this.update();

				}
			}
		},
		components: {
			InputSelect,
			MultiSelect
		},
		data() {

			this.asset = null;
			this.originalAssetUrl = '';

			return {

			}

		},
		methods: {
			collectData() {

			},
			editImage() {

				Broadcast.call("Show AssetImageInfo", [this.creative, this.asset, this.variation, this.variation.images[0]]);

			},
			deleteUpload(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete upload',
					message: `Are you sure you want to delete this uploaded file?`,
					confirmButtonText: '&nbsp;&nbsp;Delete upload',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteUpload: {
								assetUploadId: this.upload.id
							}
						});
						this.closeWindow();
					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.asset-image-original-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.btn-link
				color: #fff

			.btn-link:hover
				color: #fff

			.card-header
				display: flex
				flex-direction: row

				.date
					color: rgba(255,255,255,0.1)
					margin-left: auto

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.original
			flex-direction: column
			padding-bottom: 7px

		.images
			display: flex
			flex-direction: row
			overflow-x: auto
			scrollbar-width: none
			-ms-overflow-style: none
			scroll-behavior: smooth
			padding: 10px

			&::-webkit-scrollbar
				display: none

			&.centered
				justify-content: center

			.image
				flex-shrink: 0
				width: 250px
				height: 250px
				background-position: center
				background-size: contain
				background-repeat: no-repeat
				border-radius: 5px
				overflow: hidden
				border: 1px solid var(--gray-dark)
				box-shadow: 0px 0px 5px var(--gray-dark)
				cursor: pointer
				margin-left: 10px

				&:hover
					border-color: var(--primary)

			.image:first-child
				margin-left: 0

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>

